import {Button} from '@mintdata-wsp/common/components/button/Button';
import {Form, IFormData} from '@mintdata-wsp/common/components/form/Form';
import {ErrorPopupSide} from '@mintdata-wsp/common/components/formField/FormField';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Input} from '@mintdata-wsp/common/components/input/Input';
import {Spinner, SpinnerSize, SpinnerStyle} from '@mintdata-wsp/common/components/spinner/Spinner';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {DialogError} from '@mintdata-wsp/wsp/ui/components/forms/DialogError';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {RouteComponentProps} from 'react-router';

const styles = require('./JoinForm.less');
const cx = classnames.bind(styles);

@observer
export class JoinForm extends React.Component<RouteComponentProps<any>, any>
{
    private _form:Form = new Form({
        onSubmit: this._onFormSubmit
    });

    componentDidMount()
    {
        const {inviteCode} = this.props.match.params;

        if( !inviteCode ) return;

        controllers.ui.join.setInviteCode(inviteCode);

        controllers.ui.join.checkInviteCode().then(() =>
        {
            const {checkInviteCodeResponse, joinOrganization} = rootState.ui.joinPage;

            if( !checkInviteCodeResponse ) return;

            const {organizationName, organizationUrl, email} = checkInviteCodeResponse;

            commonControllers.analytics.main.initAllVendors();
            controllers.analytics.main.trackEvent(
                AnalyticsEventActions.WSP_INVITE_NEW_USER_LOADED,
                {
                    user_email: email,
                    org_name: organizationName,
                    org_url: organizationUrl,
                    is_user_has_wsp_account: joinOrganization,
                }
            );
        });
    }

    @bind
    private _joinOrganizationFormSubmit()
    {
        const {isInviteCodeValid} = rootState.ui.joinPage;

        if( isInviteCodeValid )
        {
            controllers.ui.join.submitForm(this._form);
        }
    }

    @bind
    private _onFormSubmit(formData:IFormData)
    {
        controllers.ui.join.submitForm(this._form);
    }

    @bind
    private _onClickJoinButton(e:React.SyntheticEvent<any>):void
    {
        this._form.submit();
    }

    @bind
    private _onClickResend(e:React.SyntheticEvent<any>):void
    {
        controllers.ui.join.requestInvitationResend();
    }

    private _getSpinner(style:SpinnerStyle, className?:string):JSX.Element
    {
        return <Spinner size={SpinnerSize.Medium_24} style={style} className={cx(className)} />;
    }

    render()
    {
        const {
            joinOrganization,
            isInviteCodeChecked,
            isCheckInviteCodeInProgress,
            checkInviteCodeResponse,
            isInviteCodeValid,
            isInvitationResent,
            isInvitationResentError,
            isInvitationResentInProgress,
            isJoinInProgress
        } = rootState.ui.joinPage;

        const controller = controllers.ui.join;

        const viewForm = !joinOrganization &&
            (isCheckInviteCodeInProgress || (checkInviteCodeResponse && checkInviteCodeResponse.allowed));

        const viewOrgName = !isInviteCodeChecked ||
            (isInviteCodeChecked && isInviteCodeValid) ||
            (isInviteCodeChecked && !isInviteCodeValid && checkInviteCodeResponse && checkInviteCodeResponse.allowed === false);

        const orgName = checkInviteCodeResponse && checkInviteCodeResponse.organizationName;
        let organizationUrl = checkInviteCodeResponse && checkInviteCodeResponse.organizationUrl;

        if( organizationUrl )
            organizationUrl = organizationUrl
                .replace('http://', '')
                .replace('https://', '')
                .replace(/\//g, '');

        const commonErrorMessage = this._form.getServerError('_');

        const email = checkInviteCodeResponse && checkInviteCodeResponse.email || '';

        const isExpired = checkInviteCodeResponse && !checkInviteCodeResponse.allowed;

        const otherError = isInviteCodeChecked && !isInviteCodeValid && !checkInviteCodeResponse;

        return (
            <Dialog className={cx('joinDialog')} title={joinOrganization ? 'Join organization' : 'Sign Up'}>

                <DialogError message={commonErrorMessage} />

                {viewOrgName && (
                    <Column>
                        <Row className={cx('orgName')}>
                            <MDIcon className={cx('icon')} name={MDIcons.common.OrganizationHouse}
                                    size={MDIconSize.large} />

                            {isCheckInviteCodeInProgress && (
                                <Row className={cx('infoText')}>
                                    Checking invitation...
                                    {this._getSpinner(SpinnerStyle.Blue, 'checkInviteCode')}
                                </Row>
                            )}

                            {(orgName || organizationUrl) && (
                                <Column className={cx('infoText')}>
                                    {orgName && <span>{orgName}</span>}
                                    {organizationUrl && <span className={cx('orgUrl')}>{organizationUrl}</span>}
                                </Column>
                            )}
                        </Row>
                        {
                            !viewForm &&
                            <Row>
                                <Button
                                    isDisabled={isCheckInviteCodeInProgress}
                                    className={cx('joinButton')}
                                    caption={'JOIN'}
                                    onClick={this._joinOrganizationFormSubmit} />
                            </Row>
                        }
                    </Column>

                )}

                {isExpired && (
                    <Column className={cx('infoText')}>
                        {!isInvitationResentError && (
                            <Row>Invitation code has expired.</Row>
                        )}
                        {isInvitationResentError && (
                            <Row className={cx('resendError')}>
                                Oops! Something went wrong.
                            </Row>
                        )}
                        {!isInvitationResent && !isInvitationResentInProgress && (
                            <Row className={cx('resendLink')} onClick={this._onClickResend}>
                                Please send me another invitation.
                            </Row>
                        )}
                        {!isInvitationResent && isInvitationResentInProgress && (
                            <Row>
                                Please send me another invitation.
                                {this._getSpinner(SpinnerStyle.Blue, 'resendLinkSpinner')}
                            </Row>
                        )}
                        {isInvitationResent && (
                            <Row className={cx('resendOk')}>
                                Request has been sent to the administrator.
                            </Row>
                        )}
                    </Column>
                )}

                {otherError && (
                    <Column className={cx('infoText')}>
                        Invitation code doesn't exist or has expired. <br />
                        Please contact your organization’s administrator.
                    </Column>
                )}

                {viewForm && (
                    <div className={cx('joinForm')}>

                        <Column>
                            <Input className={cx('input')}
                                   icon={MDIcons.common.Person}
                                   placeholder={'Full Name'}
                                   isInitiallyFocused={true}
                                   form={this._form}
                                   formKey={'fullName'}
                                   validationFn={controller.validateFullName}
                                   errorPopupSide={ErrorPopupSide.Right}
                                   isDisabled={isCheckInviteCodeInProgress}
                            />

                            <Input className={cx('input')}
                                   icon={MDIcons.common.Email}
                                   placeholder={'Email'}
                                   form={this._form}
                                   formKey={'email'}
                                   initialValue={email}
                                   isReadOnly={true}
                                   isDisabled={isCheckInviteCodeInProgress}
                            />

                            <Input className={cx('input')}
                                   icon={MDIcons.common.PasswordKey}
                                   placeholder={'Password'}
                                   isPassword={true}
                                   form={this._form}
                                   formKey={'password'}
                                   validationFn={controller.validatePassword}
                                   errorPopupSide={ErrorPopupSide.Right}
                                   isDisabled={isCheckInviteCodeInProgress}
                            />

                        </Column>

                        <Row className={cx('mainButtonRow')}>
                            <Button caption={joinOrganization ? 'Join' : 'Sign Up'}
                                    className={cx('mainButton')}
                                    onClick={this._onClickJoinButton}
                                    icon={isJoinInProgress ? this._getSpinner(SpinnerStyle.White) : null}
                                    relativeIcon={true}
                                    isDisabled={isCheckInviteCodeInProgress || isJoinInProgress}
                            />
                        </Row>

                    </div>
                )}

            </Dialog>
        );
    }
}
